import { ServiceType } from '@core/services/models/service.interface';
import { FeedServiceType } from '@core/feed/models/feed.interface';

export const getMappedService = (service: ServiceType): FeedServiceType | null => {
    switch (service) {
        case ServiceType.SKAPIEC:
            return FeedServiceType.SKAPIEC;
        case ServiceType.LAMODA:
            return FeedServiceType.LAMODA;
        case ServiceType.PERFORMANCE_EASY:
            return FeedServiceType.PERFORMANCE_EASY;
        default:
            return null;
    }
};
